import { render, staticRenderFns } from "./profile-change-favourite-restaurant.vue?vue&type=template&id=3411fe58&"
import script from "./profile-change-favourite-restaurant.vue?vue&type=script&lang=js&"
export * from "./profile-change-favourite-restaurant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports